import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import helpActions from '../actions/help';
import {getEmailLocalStorage, setEmailStorageExpiry} from '../utils/localStorageDataHandler';
import {processTranslationReplaceAll} from '../components/utils/commonUtil';
import {BRAND_NAME, LOCALES, CONTACT_PHONE_NUMBER} from '../utils/constants';

/**
 * Leverages local storage to prevent repeated submissions of users continuously
 * refreshing a page
 * @param {Object} helpFormData - The same passed to submitHelpForm
 *  -- uses helpFormData.data.message & helpForm.type
 */
const shouldSendEmail = (helpFormData) => {
    try {
        // always send non-ineligible emails
        if (helpFormData.type !== 'INELIGIBLE') {
            return true;
        }
        
        const emailSubmissions = getEmailLocalStorage();
        const INELIGIBLE_SUBTYPE = helpFormData.data.message;

        const currentTimestamp = new Date();
        const lastSubmittedExpiry = emailSubmissions[INELIGIBLE_SUBTYPE];
        // send emails for first time submissions
        if (!lastSubmittedExpiry) {
            return true;
        }

        return currentTimestamp > new Date(lastSubmittedExpiry);
    } catch (e) {
        return true; // return true if any errors occur
    }
}

function submitHelpForm(store, action) {
    const {
        helpFormData
    } = action.payload;

    if (shouldSendEmail(helpFormData)) {
        request.post(`/${config.url_prefix}/api/help`)
            .send({
                data: helpFormData
            })
            .set('x-homeaway-site', store.getState().system.siteName)
            .end((error, response) => {
                if (error) {
                    const errorKey = 'ipmob.help_page.error_msg';
                    store.dispatch(helpActions.alertError(errorKey));
                } else if (response.statusCode === 204) {
                    if (!(helpFormData.type === 'INELIGIBLE')) {
                        if(helpFormData.data && helpFormData.data.isUnlistedSoftware) {
                            const brandName = store.getState().system.brandName;

                            // Uses the same content as ineligible page for the new webform, but messaging only used in this case to indicate successful submit of form
                            const translationKey = (brandName === BRAND_NAME.vrbo && store.getState().system.preferredLocale === LOCALES.fr) ? 'ipmob.ineligible_page.content_9_CAD' : 'ipmob.ineligible_page.content_9';
                            const successKey = processTranslationReplaceAll(helpFormData.data.translations[translationKey], [brandName, CONTACT_PHONE_NUMBER]);
                            
                            store.dispatch(helpActions.alertSuccess(successKey));
                        } else {
                            store.dispatch(helpActions.alertSuccess('ipmob.help_page.success_msg'));
                        }
                    } else {
                        setEmailStorageExpiry(helpFormData);
                    }
                } else {
                    const errorKey = 'ipmob.error.process.request';
                    store.dispatch(helpActions.alertError(errorKey));
                }
                store.dispatch(actions.enableLoadOverLay(false));
            });
    } else {
        store.dispatch(actions.enableLoadOverLay(false));
    }
}

export default submitHelpForm;
